export const getInitialState = () => [];
